import { DataManager, Query } from '@syncfusion/ej2-data';
import { SwitchComponent } from '@syncfusion/ej2-react-buttons';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import {
  Column,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Inject,
  load,
  Page,
  PageSettingsModel,
  Resize,
  Search,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import {
  TextArea,
  TextAreaComponent,
  TextBoxComponent,
} from '@syncfusion/ej2-react-inputs';
import { ListViewComponent } from '@syncfusion/ej2-react-lists';
import {
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import React, { Component } from 'react';
import { getValue } from '@syncfusion/ej2-base';
import ReactDOM from 'react-dom';
import {all_information, GetErpTypeFromConfig, loadingShow} from '../../App';
import DigServices from '../../services/Dig/DigServices';
import Message from '../../utils/Message/Message';
import './style.css';
import { FaTimes } from 'react-icons/fa';
import { ThemeContext } from '../../context/theme.context';
import axios from 'axios';
import {
  Addsource_request,
  Deletesource_request,
  getsource_request,
} from '../../services/Dig/RequestSourceService/RequestSourceService';
import { getBusinessLogicConfigurationSqlValidate } from '../../services/Dig/BusinessLogicConfiguration/BusinessLogicConfigurationServices';
import {
  AddTask,
  AddTaskMapping,
  DeleteTask,
  DeleteTaskMapping,
  EditTask,
  EditTaskMapping,
  getTableNames,
  getTableWithColumnNames,
  getTask,
  getTaskMapping,
  UpdateContainerTaskByTaskId,
} from '../../services/Dig/TaskManager/TaskManagerServices';
const { Parser } = require('node-sql-parser');
const jsParser = require('js-sql-parser');

interface IProps {}
interface IState {
  selectedRows: any;
  hideAddEditDialogIsAdd: boolean;
  toolbarOptionsTask: any;
  hideAddEditDialog: boolean;
  hideEditSubDialog: boolean;
  hideDeleteDialog: boolean;
  adapterData: any;
  TaskData: any;
  TaskMapData: any;
  TableNames: any;
  TaskWithColumnData: any;
  hideDeleteDialogMapping: boolean;
  hideAddDialogMapping: boolean;
  mappingAddData: any;
  TaskWithColumnTempData: [];
  disabled: any;
}
export default class TaskManager extends Component<IProps, IState> {
  private ERP_TYPE = GetErpTypeFromConfig();
  private erpTypeName = 'MEX';
  private grid: any;
  private gridSub: any;
  private buttons: ButtonPropsModel[];
  private buttonsDelete: ButtonPropsModel[];
  private buttonsDeleteMapping: ButtonPropsModel[];
  private buttonsAddMapping: ButtonPropsModel[];
  private task_name = '';
  private sourceTable = '';
  private sourceField = '';
  private activeColumnMapping = '';
  private targetField = '';
  private mappingComments = '';
  private TextareaVal: any = '';
  private adapter = '';
  private seq = '';
  private inc_rule = '';
  private primary_key = '';
  private full_rule = '';
  private status: boolean = true;
  private enabled: boolean = true;
  private digServices = new DigServices();
  private task_id: number = -1;
  private task_map_id: number = -1;
  private isAdd: boolean = true;
  private isSub: boolean = false;
  private textareaObjAdvancedSql: any = '';
  private selIndex: any = 0;
  private mappingIsEdit = false;
  private sourceSql = '';
  private selectedGridElements: any = [];
  private log_message = '';
  private fieldsTaskName: object = {
    text: 'target_table',
    value: 'target_table',
  };
  private fieldsTaskColumnList: object = {
    text: 'FULL_TEXT',
    value: 'COLUMN_NAME',
  };
  private isActiveData = ['ACTIVE', 'INACTIVE'];
  private targetTableText = '';
  private prevSourceTable = '';
  private sourceTableData: any = [];
  private objSourceTable: any;
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  private source = axios.CancelToken.source();
  constructor(prop: IProps) {
    super(prop);
    this.grid = new GridComponent(prop);
    this.gridSub = new GridComponent(prop);
    this.buttons = [
      {
        click: () => {
          this.addAndEditTask();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideAddEditDialog: false });
        },
        buttonModel: {
          content: 'Cancel',
        },
      },
    ];
    this.buttonsDelete = [
      {
        click: () => {
          this.deleteTask();
        },
        buttonModel: {
          content: 'Yes',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDeleteDialog: false });
        },
        buttonModel: {
          content: 'No',
        },
      },
    ];
    this.buttonsDeleteMapping = [
      {
        click: () => {
          this.deleteTaskMappingNoParameter();
        },
        buttonModel: {
          content: 'Yes',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDeleteDialogMapping: false });
        },
        buttonModel: {
          content: 'No',
        },
      },
    ];
    this.buttonsAddMapping = [
      {
        click: () => {
          this.addMappingToSql();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideAddDialogMapping: false });
        },
        buttonModel: {
          content: 'Cancel',
        },
      },
    ];
    this.state = {
      selectedRows: [],
      toolbarOptionsTask: [
        {
          text: 'Add',
          tooltipText: 'Add',
          prefixIcon: 'e-add',
          id: 'add',
        },
        {
          text: 'Edit',
          tooltipText: 'Edit',
          prefixIcon: 'e-edit',
          id: 'edit',
        },
        {
          text: 'Delete',
          tooltipText: 'Delete',
          prefixIcon: 'e-delete',
          id: 'delete',
        },
        'Search',
      ],
      hideAddEditDialogIsAdd: false,
      hideAddEditDialog: false,
      hideEditSubDialog: false,
      hideDeleteDialog: false,
      TaskData: [],
      adapterData: [],
      TaskMapData: [],
      TableNames: [],
      TaskWithColumnData: [],
      hideDeleteDialogMapping: false,
      hideAddDialogMapping: false,
      mappingAddData: [],
      TaskWithColumnTempData: [],
      disabled: false,
    };
  }
  public shipFormat: object = { type: 'date', format: 'dd/MM/yyyy' };

  public toolbarOptionsTaskMapping = [
    {
      text: 'Add',
      tooltipText: 'Add',
      prefixIcon: 'e-add',
      id: 'add',
    },
    {
      text: 'Edit',
      tooltipText: 'Edit',
      prefixIcon: 'e-edit',
      id: 'edit',
    },
    {
      text: 'Delete',
      tooltipText: 'Delete',
      prefixIcon: 'e-delete',
      id: 'delete',
    },
    {
      text: 'Advanced',
      tooltipText: 'Advanced',
      prefixIcon: 'e-print-layout',
      id: 'advanced',
    },
    'Search',
  ];
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  testTarget(message: string, isError: boolean) {
    loadingShow(true, 'Checking');
    const parser = new Parser();
    let col_name = '';
    try {
      const ast = parser.astify(this.TextareaVal);
      ast.columns.forEach((el: any) => {
        col_name += el.as + ',';
      });
    } catch (er) {
      loadingShow(false, 'Checking');
      Message.error('Getting error while try SQL Parse');
      return;
    }

    col_name = col_name.substring(0, col_name.length - 1);
    let query = `select ${col_name} from ${this.targetTableText}`;
    getBusinessLogicConfigurationSqlValidate(
        {
          sql: query,
        },
        this.source
    )
        .then((el) => {
          //(el);
          let data = el.data.Messages[0];
          if (data === 'Sql Statement is correct') {
            Message.success('Sql Statement is correct for target');
            if (isError) {
              Message.error(message);
            } else {
              Message.success(message);
            }
            loadingShow(false);
          } else {
            Message.error(data);
            if (isError) {
              Message.error(message);
            } else {
              Message.success(message);
            }
            loadingShow(false);
          }
        })
        .catch((e) => {
          loadingShow(false);
          if (isError) {
            Message.error(message);
          } else {
            Message.success(message);
          }
          //(e);
        });
  }
  request() {
    let sql = this.textareaObjAdvancedSql.value;
    loadingShow(true, 'Checking');
    if (sql !== '') {
      Addsource_request({
        request_sql: sql,
        request_result: '',
        organization_id: all_information.company_id?.toString(),
        app: all_information.app,
      })
          .then((el) => {
            var data = el.data;
            this.watch(data.Log_Message);
          })
          .catch((error) => {
            if (error.response) {
              Message.error(error.response.data);
              Message.error(error.response.status);
              Message.error(error.response.headers);
            } else if (error.request) {
              Message.error(error.request);
            } else {
              Message.error('Error: ' + error.message);
            }
            Message.error(error.config);
          });
    } else {
      Message.error('No any sql to check');
      loadingShow(false);
    }
  }
  watch(request_id: any) {
    var theTimeOut = setTimeout(() => {
      Message.error('Timeout. Windows Service did not responde.');
      loadingShow(false, 'Checking');
      clearInterval(interval);
      Deletesource_request({
        request_id: request_id,
      });
    }, 6000);
    var interval = setInterval(() => {
      getsource_request(request_id)
          .then((el) => {
            var getData = el.data[0];
            var expectMessage = 'Sql statement is correct';
            if (getData.request_result !== '') {
              clearInterval(interval);
              clearTimeout(theTimeOut);
              loadingShow(false);
              if (
                  expectMessage.toLowerCase() ===
                  getData.request_result.toLowerCase()
              ) {
                this.testTarget(expectMessage + ' for source', false);
              } else {
                this.testTarget(getData.request_result + ' for source', true);
              }
              Deletesource_request({
                request_id: request_id,
              });
            }
          })
          .catch((e) => {
            //(e);
            this.testTarget('Fatal error! For source', true);
          });
    }, 500);
  }
  toolbarClick(args: any) {
    if (args.item.id === 'add') {
      this.isAdd = true;
      this.task_name = '';
      this.adapter = '';
      this.seq = '';
      this.inc_rule = '';
      this.primary_key = '';
      this.full_rule = '';
      this.status = false;
      this.enabled = false;
      this.targetTableText = '';
      this.sourceTable = '';
      this.setState({ hideAddEditDialogIsAdd: true, hideAddEditDialog: true });
    }
    if (args.item.id === 'delete') {
      if (this.grid.getSelectedRecords()) {
        if (this.grid.getSelectedRecords().length > 0) {
          this.selectedGridElements = this.grid.getSelectedRecords() as any;
          this.task_id = this.selectedGridElements[0].task_id;
          this.isSub = false;
          this.isSub = false;
          this.setState({ hideDeleteDialog: true });
        }
      }
    }
    if (args.item.id === 'edit') {
      if (this.grid.getSelectedRecords()) {
        if (this.grid.getSelectedRecords().length > 0) {
          var selectedElement = this.grid.getSelectedRecords() as any;
          this.isAdd = false;
          this.seq = selectedElement[0].seq;
          this.inc_rule = selectedElement[0].inc_rule;
          this.primary_key = selectedElement[0].primary_key;
          this.full_rule = selectedElement[0].full_rule;
          this.adapter = selectedElement[0].adapter_id;
          this.task_name = selectedElement[0].task_name;
          this.status = selectedElement[0].status;
          this.enabled = selectedElement[0].enabled;
          this.task_id = selectedElement[0].task_id;
          this.sourceTable = selectedElement[0].source_table;
          this.targetTableText = selectedElement[0].target_table;
          this.sourceSql = selectedElement[0].source_sql;
          this.setState({
            hideAddEditDialogIsAdd: false,
            hideAddEditDialog: true,
          });
        }
      }
    }
  }
  addMappingToSql = () => {
    const dataTask = this.grid.getSelectedRecords()[0];
    const targetTable = this.targetTableText;
    const targetField = this.targetField;
    const sourceTable = this.sourceTable;
    const sourceField = this.sourceField;
    const comments = this.mappingComments;
    const activeMapping = this.activeColumnMapping;
    if (targetField === '') {
      Message.error('Target Field can not be empty');
      return false;
    }
    if (sourceField === '') {
      Message.error('Source Field can not be empty');
      return false;
    }
    if (activeMapping === '') {
      Message.error('Active can not be empty');
      return false;
    }
    var selectedElementMapping = this.gridSub.getSelectedRecords()[0] as any;
    if (this.mappingIsEdit) {
      if (selectedElementMapping.target_field !== targetField) {
        const findTarget = this.state.TaskMapData.find(
            (x: any) => x.target_field === targetField
        );
        if (findTarget !== undefined) {
          Message.error(
              'column ' + targetField + ' already exists in the table'
          );
          return false;
        }
      }
      if (selectedElementMapping.source_field !== sourceField) {
        const findSource = this.state.TaskMapData.find(
            (x: any) => x.source_field === sourceField
        );
        if (findSource !== undefined) {
          Message.error(
              'column ' + sourceField + ' already exists in the table'
          );
          return false;
        }
      }
    } else {
      const findTarget = this.state.TaskMapData.find(
          (x: any) => x.target_field === targetField
      );
      if (findTarget !== undefined) {
        Message.error('column ' + targetField + ' already exists in the table');
        return false;
      }
      const findSource = this.state.TaskMapData.find(
          (x: any) => x.source_field === sourceField
      );
      if (findSource !== undefined) {
        Message.error('column ' + sourceField + ' already exists in the table');
        return false;
      }
    }
    const parser = new Parser();
    try {
      this.sourceSql = dataTask.source_sql as string;
      var all_columns_seperated = this.sourceSql.split(' as ');
      let old_terms_in_sql = '';
      let new_terms_in_sql = '';
      let theCurrentFieldInSql = '';
      for (var i = 1; i < all_columns_seperated.length; i++) {
        if (all_columns_seperated[i].indexOf(targetField) !== -1) {
          old_terms_in_sql = all_columns_seperated[i];
          break;
        }
      }
      if (old_terms_in_sql.indexOf('--') !== -1) {
        new_terms_in_sql = old_terms_in_sql.replace(
            selectedElementMapping.comments,
            comments
        );
        this.sourceSql = this.sourceSql.replace(
            old_terms_in_sql,
            new_terms_in_sql
        );
      }
      let message = '';
      if (this.mappingIsEdit) {
        this.sourceSql = this.sourceSql.replace(
            selectedElementMapping.target_field,
            targetField
        );
        this.sourceSql = this.sourceSql.replace(
            selectedElementMapping.source_field,
            sourceField
        );
      } else {
        if (this.sourceSql !== '' && this.sourceSql !== null) {
          const ast = parser.astify(this.sourceSql);
          let obj = {
            as: targetField,
            expr: {
              column: sourceField,
              table: sourceTable,
              type: 'column_ref',
            },
          };
          ast.columns.push(obj);
          let newSql = parser.sqlify(ast);
          this.sourceSql = newSql.replaceAll('`', '');
        } else {
          this.sourceSql =
              'select ' +
              sourceTable +
              '.' +
              sourceField +
              ' as ' +
              targetField +
              ' from ' +
              sourceTable;
        }
      }

      let theObj = {
        task_name: dataTask.task_name,
        task_id: dataTask.task_id,
        adapter_id: dataTask.adapter_id,
        adapter_name: dataTask.adapter_name,
        service_type: dataTask.service_type,
        seq: dataTask.seq,
        status: dataTask.status,
        enabled: dataTask.enabled,
        target_table: dataTask.target_table,
        source_table: '',
        source_sql: `SELECT * from ${this.targetTableText}`,
        log_message: this.log_message,
        organization_id: all_information.organization_id,
      };
      EditTask(theObj)
          .then((res: any) => {})
          .catch((err) => {
            message += err + '\n';
          });

      const obj = {
        map_id:
            selectedElementMapping === undefined
                ? -1
                : selectedElementMapping.map_id,
        task_id: dataTask.task_id,
        task_name: dataTask.task_name,
        target_field: targetField,
        source_field: sourceField,
        source_table: sourceTable,
        target_table: targetTable,
        comments: comments,
        active: activeMapping === 'ACTIVE' ? true : false,
        organization_id: all_information.company_id,
        created_by: all_information.user_id,
      };
      if (this.mappingIsEdit) {
        EditTaskMapping(obj)
            .then((res) => {})
            .catch((err) => (message += err + '\n'));
      } else {
        AddTaskMapping(obj)
            .then((res) => {})
            .catch((err) => (message += err + '\n'));
      }
      if (message === '') {
        setTimeout(() => {
          Message.success('Successful');
          this.getTask();
          this.getTaskMap(dataTask.task_id);
          this.setState({ hideAddDialogMapping: false });
        }, 1000);
      } else {
        Message.error(message);
      }
      this.grid.selectedRowIndex = this.selIndex;
      this.getTaskMap(dataTask.task_id);
    } catch (error) {
      Message.error(error as string);
    }
  };
  getTableNames() {
    getTableNames().then((res) => {
      const model = res.data.map((item: any) => {
        if (item.TABLE_NAME == 'jobcacte' || item.TABLE_NAME == 'job5mfj') {
          return {
            target_table: item.TABLE_NAME,
          };
        }
      });
      let updatedModel : any[]=[];
      if(this.erpTypeName === this.ERP_TYPE){
        updatedModel= [
          { target_table: 'AccountCode' },
          { target_table: 'Asset' },
          { target_table: 'Department' },
          { target_table: 'PreventativeMaintenance' },
          { target_table: 'WorkOrder' },
          { target_table: 'WorkOrderOperation' },
          { target_table: 'TempWorkOrder' },
          { target_table: 'TempWorkOrderOperation' },
        ];
      }
      else{
        updatedModel= [{ target_table: 'temp_job5mfj' }, { target_table: 'temp_jobcacte'}, ...model];
      }
      this.setState({ TableNames: updatedModel });
    });
  }
  async getTaskWithColumnName(taskName: string) {
    await getTableWithColumnNames(taskName, this.source).then((res) => {
      var model = res.data.map((item: any) => {
        return {
          COLUMN_NAME: item.COLUMN_NAME,
          FULL_TEXT:
              item.DATA_TYPE === 'int' || item.DATA_TYPE === 'datetime'
                  ? item.COLUMN_NAME + ' --- ' + item.DATA_TYPE
                  : item.COLUMN_NAME +
                  ' --- ' +
                  item.DATA_TYPE +
                  '(' +
                  item.CHARACTER_MAXIMUM_LENGTH +
                  ')',
        };
      });
      this.setState({ TaskWithColumnData: model });
    });
  }
  componentDidMount() {
    this.getTask();
    this.getTableNames();
    this.getAdapter();
    this.grid.selectedRowIndex = this.selIndex;
  }
  componentWillUnmount(): void {
    if (this.source) {
    }
  }
  async addAndEditTask() {
    var selectedElement = this.grid.getSelectedRecords()[0] as any;
    if (this.task_name === '') {
      Message.error('Task name cannot be empty');
      return;
    }
    if (this.adapter === '') {
      Message.error('Adapter cannot be empty');
      return;
    }

    if (this.targetTableText === '') {
      Message.error('Target Table cannot be empty');
      return;
    }
    if (this.seq === '') {
      Message.error('Seq cannot be empty');
      return;
    }
    if (this.seq === '') {
      Message.error('Seq cannot be empty');
      return;
    }
    let targetTable= this.targetTableText
    let sql= `SELECT * from ${targetTable}`
    if(this.targetTableText == 'temp_job5mfj'){
      targetTable=  'temp_job5mfj';
      sql= `SELECT * from job5mfj`;
    }
    if(this.targetTableText == 'temp_jobcacte'){
      targetTable=  'temp_jobcacte';
      sql= `SELECT * from jobcacte`;
    }

    if(this.targetTableText == 'TempWorkOrder'){
      targetTable=  'TempWorkOrder';
      sql= `SELECT WorkOrderID from WorkOrder`;
    }
    if(this.targetTableText == 'TempWorkOrderOperation'){
      targetTable=  'TempWorkOrderOperation';
      sql= `SELECT WorkOrderTradeID from WorkOrderTrade`;
    }

    let theObj: any = {
      task_name: this.task_name,
      task_id: this.task_id,
      adapter_id: this.adapter,
      adapter_name: $('#adapterTaskManager').val(),
      service_type: '',
      seq: this.seq,
      inc_rule: this.inc_rule,
      primary_key: this.primary_key,
      full_rule: this.full_rule,
      status: this.status,
      enabled: this.enabled,
      target_table: targetTable,
      source_table: this.sourceTable,
      source_sql: sql,
      log_message: this.log_message,
      organization_id: all_information.company_id,
      created_by: all_information.user_id,
      target_fields: '',
      isIncrementalProccess: false,
      isFull: true,
    };

    if (this.isAdd) {
      delete theObj.task_id;
      theObj.erp_type_name= this.ERP_TYPE;

      loadingShow(true);
      await AddTask(theObj)
          .then(async (el) => {
            this.setState({ hideAddEditDialog: false });
            loadingShow(false);
            this.getTask();
            Message.success('Success');
          })
          .catch((er) => {
            if (er.response) {
              Message.error(
                  er.response.data +
                  '\n' +
                  er.response.status +
                  '\n' +
                  er.response.headers
              );
            } else if (er.request) {
              Message.error(er.request);
            } else {
              Message.error('Error: ' + er.message);
            }
            Message.error(er.config);
          });
    } else {
      loadingShow(true);
      await EditTask(theObj)
          .then((el) => {
            UpdateContainerTaskByTaskId(theObj).catch((er) => {
            });
            this.getTask();
            loadingShow(false);
            this.setState({ hideAddEditDialog: false });
            Message.success('Success');
          })
          .catch((er) => {
            if (er.response) {
              Message.error(
                  er.response.data +
                  '\n' +
                  er.response.status +
                  '\n' +
                  er.response.headers
              );
            } else if (er.request) {
              Message.error(er.request);
            } else {
              Message.error('Error: ' + er.message);
            }
            Message.error(er.config);
          });
    }
  }

  takeCommandIntoSql(index: any, sql: string) {
    sql = sql.toLocaleLowerCase('en-EN');
    var start_index = sql.trim().indexOf('select') + 6;
    var end_index = sql.trim().lastIndexOf('from') - 1;
    var parsing_select_from = sql.substring(start_index, end_index);
    var parseAcAs = parsing_select_from.split(',');
    var pharantesesOpenCount = 0;
    var pharantesesCloseCount = 0;
    for (let i = 0; i < parsing_select_from.length; i++) {}
    var theParam = parseAcAs[index] as string;
    var collector = '';
    if (theParam.indexOf('select') != -1 && theParam.indexOf('case') == -1) {
      var openBracketIndex = theParam.indexOf('(');
      var closeBracketIndex = theParam.indexOf(')') + 1;
      var theSubSection = theParam.substring(
          openBracketIndex,
          closeBracketIndex
      );
      var modifyElement = theParam.replace(theSubSection, 'XDDEXXW ');
      var partOfTheAs = modifyElement.split(' as ')[1].trim();
      var partOfTheCommand = partOfTheAs.indexOf('--');
      if (partOfTheCommand !== -1) {
        for (var j = partOfTheCommand; j < partOfTheAs.length; j++) {
          if (
              partOfTheAs[j] == ',' ||
              partOfTheAs[j] == '\r' ||
              partOfTheAs[j] == '\n'
          )
            break;
          collector += partOfTheAs[j];
        }
      }
    } else if (theParam.indexOf('case') != -1) {
      var openBracketIndex = theParam.indexOf('case');
      var closeBracketIndex = theParam.indexOf('end') + 3;
      var theSubSection = theParam.substring(
          openBracketIndex,
          closeBracketIndex
      );
      var modifyElement = theParam.replace(theSubSection, 'XDDEXXW ');
      var partOfTheAs = modifyElement.split(' as ')[1].trim();
      var partOfTheCommand = partOfTheAs.indexOf('--');
      if (partOfTheCommand !== -1) {
        for (var j = partOfTheCommand; j < partOfTheAs.length; j++) {
          if (
              partOfTheAs[j] == ',' ||
              partOfTheAs[j] == '\r' ||
              partOfTheAs[j] == '\n'
          )
            break;
          collector += partOfTheAs[j];
        }
      }
    } else {
      var partOfTheAs = theParam.split(' as ')[1].trim();
      var partOfTheCommand = partOfTheAs.indexOf('--');
      if (partOfTheCommand !== -1) {
        for (var j = partOfTheCommand; j < partOfTheAs.length; j++) {
          if (
              partOfTheAs[j] == ',' ||
              partOfTheAs[j] == '\r' ||
              partOfTheAs[j] == '\n'
          )
            break;
          collector += partOfTheAs[j];
        }
      }
    }
    return collector;
  }
  checkRightAfterComma(theCase: string, theSql: string) {
    var regex = new RegExp(',\n *' + theCase, 'g');
    var match = regex.exec(theSql);
    if (match) {
      return true;
    } else {
      return false;
    }
  }
  private getSelctSideIndex = (sql: string) => {
    // let regex = /,(\s*\()|,(?:\s*select)/i;
    let regex = /,(?:(?:(?!case|end)\s)*\()|,(?:(?:(?!case|end)\s)*select)/;
    let match = sql.match(regex);
    if (match && match.index !== undefined) {
      return match.index;
    } else {
      return -1;
    }
  };
  private parseSpeacialCases = (sql: string) => {
    var regex = /,\n (.*?) \|\| /;
    var match = regex.exec(sql);
    if (match) {
      return match[0].substring(1, match[0].length - 1);
    } else {
      return '';
    }
  };
  private parseAdvanceSql = (
      theSql: string,
      cases: Array<string>,
      inc_rule: string
  ) => {
    if (theSql === '' || theSql === undefined) {
      Message.error('Source sql not found.');
      return;
    }
    var theStartIndex = 0;
    var theLastIndex = 0;
    var theSimple = '';
    let theIsReachOutTheAs = false;
    theSql = theSql.replaceAll('[', '');
    theSql = theSql.replaceAll(']', '');
    theSql = theSql.replaceAll('\t', '');
    theSql = theSql.replaceAll('\n', '\n  ');
    theSql = theSql.replaceAll(',\n', ',');
    theSql = theSql.replaceAll(',', ',\n');
    theSql = theSql.toLocaleLowerCase('eng-EN');
    let theSerializableElements: Array<any> = [];
    let theOriginalSQL = theSql;
    let theINCSql = theOriginalSQL;
    let tableName = '';
    ['inner', 'left', 'right', 'outhor'].map((elJ) => {
      let theIndex = theSql.indexOf(elJ);
      if (theIndex !== -1) {
        theSql = theSql.substring(0, theIndex);
      }
    });
    tableName = theSql.substring(theSql.lastIndexOf('from'), theSql.length);
    let occurencesNonWhiteSpaceCharacter: boolean = false;
    if (theSql.lastIndexOf('where') !== -1) {
      theSql = theSql.substring(0, theSql.lastIndexOf('where'));
    }
    let tempOfTheFromSide = theOriginalSQL.substring(
        theOriginalSQL.lastIndexOf(tableName),
        theOriginalSQL.length
    );
    theINCSql = theINCSql.replace(tempOfTheFromSide, ' xxxFROMINCXXX ');
    let tempOfTheFromSideINC = tempOfTheFromSide;
    let theWhereSide = '';
    if (!inc_rule && inc_rule !== null) {
      if (tempOfTheFromSideINC.indexOf('where') !== -1) {
        theWhereSide = tempOfTheFromSideINC.substring(
            tempOfTheFromSideINC.lastIndexOf('where'),
            tempOfTheFromSideINC.length - 1
        );
        tempOfTheFromSideINC = tempOfTheFromSideINC.replace(
            theWhereSide,
            ' xxxWHEREXXX '
        );
        theWhereSide = theWhereSide.replace('where', '');
        theWhereSide = 'where ' + inc_rule + ' and ' + theWhereSide;
        tempOfTheFromSideINC = tempOfTheFromSideINC.replace(
            ' xxxWHEREXXX ',
            theWhereSide
        );
      } else {
        theWhereSide = 'where ' + inc_rule;
        tempOfTheFromSideINC += ' ' + theWhereSide;
      }
    }
    theSql = theSql.substring(0, theSql.lastIndexOf('from'));
    let isLastSelectCommand = false;
    let theTempOfCurrentCase = '';
    cases.map((el, index) => {
      theTempOfCurrentCase = el;
      if (el === '||') {
        let theCase = this.parseSpeacialCases(theSql);
        if (theCase !== '') {
          el = theCase;
        }
      }
      if (el === 'select') {
        while (this.getSelctSideIndex(theSql) !== -1) {
          theStartIndex = this.getSelctSideIndex(theSql) + 1;
          theSimple = '';
          let theCurrentCase: any = { case: '', as: '' };
          occurencesNonWhiteSpaceCharacter = false;
          isLastSelectCommand = false;
          for (let i = theStartIndex; i < theSql.length; i++) {
            const theChar = theSql[i];
            theSimple += theChar;
            if (!theIsReachOutTheAs) {
              if (theSimple.includes(' as ')) {
                theIsReachOutTheAs = true;
                theCurrentCase.case = theSimple.replace(' as ', '').trim();
                theCurrentCase.case = theCurrentCase.case.replace(
                    '11UW',
                    ' as '
                );
                theSimple = theSimple.replace('11UW', ' as ');
                theCurrentCase.as = '';
              }
            } else {
              theCurrentCase.as += theSql[i];
              if (
                  (theCurrentCase.as.trimStart().includes(' ') ||
                      theCurrentCase.as.trimStart().includes('\n')) &&
                  theCurrentCase.as.trimStart().length !== 0
              )
                occurencesNonWhiteSpaceCharacter = true;
              if (theChar === ',' || i === theSql.length - 1) {
                if (i === theSql.length - 1) {
                  isLastSelectCommand = true;
                }
                theLastIndex = i;
                theIsReachOutTheAs = false;
                theCurrentCase.as = theCurrentCase.as?.replace(',', '')?.trim();
                break;
              } else if (
                  theChar !== ',' &&
                  theChar !== ' ' &&
                  theChar !== '\n' &&
                  occurencesNonWhiteSpaceCharacter
              ) {
                theSimple = theSimple.replace(' as ', '11UW');
                occurencesNonWhiteSpaceCharacter = false;
                theIsReachOutTheAs = false;
              }
            }
          }
          if (theCurrentCase.as === '' || theCurrentCase.case === '') {
            alert('Propably missing AS key.' + theSimple);
            return;
          }
          let theCode = Math.random();
          theCurrentCase.code = theCode;
          theSerializableElements.push(theCurrentCase);
          theSql = theSql.replace(theSimple, '');
          if (!isLastSelectCommand) {
            theOriginalSQL = theOriginalSQL.replace(
                theSimple,
                `'${theCode}' as '${theCode}',`
            );
          } else {
            theOriginalSQL = theOriginalSQL.replace(
                theSimple,
                `'${theCode}' as '${theCode}'  `
            );
          }
        }
      } else {
        if (this.checkRightAfterComma(el, theSql)) {
          while (theSql.toLocaleLowerCase('eng-EN').indexOf(el) !== -1) {
            theStartIndex = theSql.toLocaleLowerCase('eng-EN').indexOf(el);
            theSimple = '';
            let theCurrentCase: any = { case: '', as: '' };
            occurencesNonWhiteSpaceCharacter = false;
            isLastSelectCommand = false;
            for (let i = theStartIndex; i < theSql.length; i++) {
              const theChar = theSql[i];
              theSimple += theChar;
              if (!theIsReachOutTheAs) {
                if (theSimple.includes(' as ')) {
                  theIsReachOutTheAs = true;
                  theCurrentCase.case = theSimple.replace(' as ', '').trim();
                }
              } else {
                theCurrentCase.as += theSql[i];
                if (theSql[i] !== ' ' || theSql[i] !== '\n')
                  occurencesNonWhiteSpaceCharacter = true;
                if (theChar === ',' || i === theSql.length - 1) {
                  if (i === theSql.length - 1) {
                    isLastSelectCommand = true;
                  }
                  theLastIndex = i;
                  theIsReachOutTheAs = false;
                  theCurrentCase.as = theCurrentCase.as
                      ?.replace(',', '')
                      ?.trim();
                  break;
                } else if (
                    theChar === ' ' &&
                    occurencesNonWhiteSpaceCharacter
                ) {
                }
              }
            }
            if (theCurrentCase.as === '' || theCurrentCase.case === '') {
              alert('Propably missing AS key.' + theSimple);
              return;
            }
            let theCode = Math.random();
            theCurrentCase.code = theCode;
            theSerializableElements.push(theCurrentCase);
            theSql = theSql.replace(theSimple, '');
            if (!isLastSelectCommand) {
              theOriginalSQL = theOriginalSQL.replace(
                  theSimple,
                  `'${theCode}' as '${theCode}',`
              );
            } else {
              theOriginalSQL = theOriginalSQL.replace(
                  theSimple,
                  `'${theCode}' as '${theCode}'  `
              );
            }
            if (theTempOfCurrentCase === '||') {
              let theCase = this.parseSpeacialCases(theOriginalSQL);
              if (theCase !== '') {
                el = theCase;
              }
            }
          }
        }
      }
    });
    theSql = theSql.trim();
    if (theSql[theSql.length - 1] === ',') {
      theSql = theSql.substring(0, theSql.length - 1);
    }
    theSql = theSql + ' ' + tempOfTheFromSide;
    theINCSql = theINCSql.replace(' xxxFROMINCXXX ', tempOfTheFromSideINC);
    var theSqlWithoutClause = theOriginalSQL.substring(
        0,
        theOriginalSQL.indexOf(tableName) + tableName.length
    );
    tableName = tableName.trim().replace('from', '');
    if (tableName.indexOf('where') > 0) {
      tableName = tableName.substring(0, tableName.indexOf('where'));
    }
    return {
      pureSql: theSql,
      serialized: theSerializableElements,
      tableName: tableName,
      inc_sql: theINCSql,
      originalSQL: theOriginalSQL,
      noWhereClause: theSqlWithoutClause,
    };
  };
  async addAndEditTaskMapp() {
    const dataTask = this.grid.getSelectedRecords()[0];
    this.sourceSql = this.textareaObjAdvancedSql.value;
    var thePureSql = this.textareaObjAdvancedSql.value;
    if (this.sourceSql === '' || this.sourceSql === 'null') {
      let theObj = {
        task_name: dataTask.task_name,
        task_id: dataTask.task_id,
        adapter_id: dataTask.adapter_id,
        adapter_name: dataTask.adapter_name,
        service_type: dataTask.service_type,
        seq: dataTask.seq,
        status: dataTask.status,
        enabled: dataTask.enabled,
        target_table: dataTask.target_table,
        source_table: dataTask.source_table,
        source_sql: this.sourceSql,
        log_message: this.log_message,
        organization_id: all_information.company_id,
        created_by: all_information.user_id,
        erp_type_name: this.ERP_TYPE
      };
      await EditTask(theObj)
          .then((res: any) => {})
          .catch((err) => {
            if (err.response) {
              Message.error(err.response.data);
              Message.error(err.response.status);
              Message.error(err.response.headers);
            } else if (err.request) {
              Message.error(err.request);
            } else {
              Message.error('Error: ' + err.message);
            }
          });

      await this.state.TaskMapData.map((item: any) => {
        let obj = {
          map_id: item.map_id,
        };
        DeleteTaskMapping(obj)
            .then()
            .catch((err) => {
              if (err.response) {
                Message.error(err.response.data);
                Message.error(err.response.status);
                Message.error(err.response.headers);
              } else if (err.request) {
                Message.error(err.request);
              } else {
                Message.error('Error: ' + err.message);
              }
            });
      });
      this.getTask();
      this.setState({ hideEditSubDialog: false });
    } else {
      try {
        let isRowId = false;
        let all_target_fields = '';
        let data: any = [];
        while (this.sourceSql.indexOf('--') !== -1) {
          var theFirstIndexForComment = this.sourceSql.indexOf('--');
          var theLastIndexForComment = -1;
          for (
              var i = theFirstIndexForComment;
              i < this.sourceSql.length;
              i++
          ) {
            if (
                this.sourceSql[i] == '\r' ||
                this.sourceSql[i] == '\n' ||
                this.sourceSql[i] == ','
            ) {
              theLastIndexForComment = i - 1;
              break;
            }
          }
          let theSubQuery = this.sourceSql.substring(
              theFirstIndexForComment,
              theLastIndexForComment + 1
          );
          this.sourceSql = this.sourceSql.replace(theSubQuery, '');
        }
        const theResultOfAdvanceParser = this.parseAdvanceSql(
            this.sourceSql.trim(),
            [
              'concat',
              'row_number()',
              'select',
              'case',
              'upper',
              'dense_rank()',
              '||',
              'ltrim',
              'rtrim',
            ],

            dataTask.inc_rule
        );
        if (!theResultOfAdvanceParser) {
          return;
        }
        const js_parser = jsParser.parse(
            theResultOfAdvanceParser.noWhereClause
        );
        // const ast = parser.astify(this.sourceSql); //[mysql sql grammer parsed by default]
        if (js_parser.value.selectItems === null) {
          Message.error('You must select a column');
          return false;
        } else {

          var current_comment = '';
          let sourceTable = '';
          if (js_parser.value.from.value.length > 1) {
            if (js_parser.value.selectItems === null) {
              throw new Error(
                  'Select  table.column from table ,it should be like this'
              );
            } else {
              if (
                  js_parser.value.from.value[0].value.type ===
                  'InnerCrossJoinTable'
              ) {
                sourceTable =
                    js_parser.value.from.value[0].value.right.value.value;
              } else {
                sourceTable = js_parser.value.from.value[0].value.value.value;
              }
            }
          } else {
            if (
                js_parser.value.from.value[0].value.type === 'InnerCrossJoinTable'
            ) {
              sourceTable =
                  js_parser.value.from.value[0].value.right.value.value;
            } else if (
                js_parser.value.from.value[0].value.type === 'LeftRightJoinTable'
            ) {
              sourceTable =
                  js_parser.value.from.value[0].value.left.left.value.value;
            } else {
              sourceTable = js_parser.value.from.value[0].value.value.value;
            }
          }
          let source_field = '';
          js_parser.value.selectItems.value.map((sql: any, index: number) => {
            if (!sql.hasAs) {
              Message.error('There must be an "as" in the column');
              return false;
            }
            const isTargetfield = this.state.TaskWithColumnData.find(
                (x: any) =>
                    (x.COLUMN_NAME as string).toLowerCase() ===
                    sql.alias.toLowerCase()
            );
            let theIndexOFCurrent =
                theResultOfAdvanceParser.serialized.findIndex(
                    (el) => `'${el.code}'` === sql.alias.toLowerCase()
                );
            if (theIndexOFCurrent !== -1) {
              sql.alias =
                  theResultOfAdvanceParser.serialized[theIndexOFCurrent].as;
              sql.value =
                  theResultOfAdvanceParser.serialized[theIndexOFCurrent].case;
            } else {
              if (isTargetfield === undefined) {
                throw new Error(
                    'Table ' +
                    dataTask.target_table +
                    ' has no ' +
                    sql.alias +
                    ' column'
                );
              }
            }
            if (sql.type === 'Identifier') {
              if (sql.value?.includes('row_id')) {
                isRowId = true;
              }
            }
            if (sql.type === 'Identifier') {
              source_field = sql.value;
            } else if (sql.type === 'SubQuery') {
              source_field = 'innerQuery';
            } else if (sql.type === 'String') {
              source_field = sql.value;
            } else if (sql.type === 'FunctionCall') {
              source_field = sql?.params[0].value;
            } else if (sql.type === 'CaseWhen') {
              source_field = 'caseWhen';
            } else {
              source_field = `Unknown call ${sql.type}`;
            }
            all_target_fields += sql.alias + ',';
            const obj = {
              task_id: dataTask.task_id,
              task_name: dataTask.task_name,
              target_field: sql.alias,
              source_field: source_field,
              source_table: sourceTable,
              target_table: dataTask.target_table,
              comments: current_comment,
              active: true,
              organization_id: all_information.company_id,
              created_by: all_information.user_id,
            };
            data.push(obj);
          });
          if (isRowId === false) {
            Message.error('There must be an "row_id" in the column');
            return false;
          }
          let message = '';
          await DeleteTaskMapping(this.state.TaskMapData)
              .then((res: any) => {
                //(res);
              })
              .catch((err) => (message += err + '\n'));
          let theObj = {
            task_name: dataTask.task_name,
            task_id: dataTask.task_id,
            adapter_id: dataTask.adapter_id,
            adapter_name: dataTask.adapter_name,
            service_type: dataTask.service_type,
            seq: dataTask.seq,
            status: dataTask.status,
            enabled: dataTask.enabled,
            target_table: dataTask.target_table,
            source_table: theResultOfAdvanceParser.tableName,
            source_sql: this.sourceSql,
            log_message: this.log_message,
            organization_id: all_information.company_id,
            created_by: all_information.user_id,
            target_fields: all_target_fields,
            inc_sql: theResultOfAdvanceParser.inc_sql,
          };
          //(theObj);

          await EditTask(theObj)
              .then((res: any) => {
                //(res);
              })
              .catch((err) => {
                message += err + '\n';
              });

          await AddTaskMapping(data)
              .then((res) => {
                //(res);
              })
              .catch((err) => {
                message += err + '\n';
              });

          if (message === '') {
            setTimeout(() => {
              Message.success('Successful');
              this.getTask();
              this.getTaskMap(dataTask.task_id);
              this.setState({
                hideEditSubDialog: false,
              });
            }, 1000);
          } else {
            Message.error(message);
          }
        }
      } catch (error) {
        alert(error);
      }
    }
    this.grid.selectedRowIndex = this.selIndex;
    this.getTaskMap(dataTask.task_id);
  }
  deleteTaskMappingNoParameter() {
    try {
      if (this.gridSub.getSelectedRecords().length > 0) {
        var selectedElementTask = this.grid.getSelectedRecords() as any;
        var selectedElementMap = this.gridSub.getSelectedRecords() as any;
        const parser = new Parser();

        this.sourceSql = selectedElementTask[0].source_sql;

        const ast = parser.astify(this.sourceSql);

        let cleanSql = '';
        if (this.sourceSql) {
          const findCol = ast.columns.findIndex(
              (x: any) => x.as === selectedElementMap[0].target_field
          );
          ast.columns.splice(findCol, 1);
          var sqlParse = parser.sqlify(ast);
          cleanSql = sqlParse.replaceAll('`', '');
          if (ast.columns.length <= 0) cleanSql = '';
        }
        let message = '';
        let theObj = {
          task_name: selectedElementTask[0].task_name,
          task_id: selectedElementTask[0].task_id,
          adapter_id: selectedElementTask[0].adapter_id,
          adapter_name: selectedElementTask[0].adapter_name,
          service_type: selectedElementTask[0].service_type,
          seq: selectedElementTask[0].seq,
          status: selectedElementTask[0].status,
          enabled: selectedElementTask[0].enabled,
          target_table: selectedElementTask[0].target_table,
          source_table: selectedElementTask[0].source_table,
          source_sql: cleanSql,
          log_message: this.log_message,
        };
        EditTask(theObj)
            .then((res: any) => {})
            .catch((err) => {
              if (err.response) {
                Message.error(
                    err.response.data +
                    '\n' +
                    err.response.status +
                    '\n' +
                    err.response.headers
                );
              } else if (err.request) {
                Message.error(err.request);
              } else {
                Message.error('Error: ' + err.message);
              }
              message += err + '\n';
            });
        //ve mapping tablosunda o satiri siliyoruz
        let objDelete = {
          map_id: selectedElementMap[0].map_id,
        };
        DeleteTaskMapping(objDelete)
            .then((el) => {
              this.setState({ hideDeleteDialogMapping: false });
            })
            .catch((err) => (message += err + '\n'));

        if (message === '') {
          setTimeout(() => {
            Message.success('Successful');
            this.getTask();
            this.getTaskMap(selectedElementTask[0].task_id);
          }, 500);
        } else Message.error(message);
      } else {
        Message.error('No records selected Mapping');
      }

      this.grid.selectedRowIndex = this.selIndex;
    } catch (error) {
      Message.error(error as string);
    }
  }
  async deleteTask() {
    this.selectedGridElements.map(
        async (eachGridElement: { task_id: number }) => {
          let theObj = {
            task_id: eachGridElement.task_id,
          };
          let theObjSuv = {
            map_id: this.task_map_id,
          };
          if (!this.isSub) {
            await DeleteTask(theObj)
                .then((el) => {
                  this.getTask();
                  this.setState({ hideDeleteDialog: false });
                  Message.success('Success');
                })
                .catch((er) => {
                  if (er.response) {
                    Message.error(
                        er.response.data +
                        '\n' +
                        er.response.status +
                        '\n' +
                        er.response.headers
                    );
                  } else if (er.request) {
                    Message.error(er.request);
                  } else {
                    Message.error('Error: ' + er.message);
                  }
                  Message.error(er.config);
                });
          } else {
            await DeleteTaskMapping(theObjSuv)
                .then((el) => {
                  this.getTaskMap(this.task_id);
                  this.setState({ hideDeleteDialog: false });
                  Message.success('Success');
                })
                .catch((er) => {
                  if (er.response) {
                    Message.error(
                        er.response.data +
                        '\n' +
                        er.response.status +
                        '\n' +
                        er.response.headers
                    );
                  } else if (er.request) {
                    Message.error(er.request);
                  } else {
                    Message.error('Error: ' + er.message);
                  }
                  Message.error(er.config);
                });
          }
        }
    );
  }
  getTask() {
    getTask({ org_id: all_information.company_id }, this.source)
        .then((el) => {
          const model = el.data.map((item: any) => {
            return {
              ...item,
              companyName: all_information.company_name,
            };
          });
          this.setState({ TaskData: model });
        })
        .catch((e) => {
          //(e);
        });
  }
  getAdapter() {
    this.digServices
        .getSourceAdaptors({ org_id: all_information.company_id }, this.source)
        .then((el) => {
          this.setState({ adapterData: el.data });
        })
        .catch((er) => {
          if (er.response) {
            Message.error(
                er.response.data +
                '\n' +
                er.response.status +
                '\n' +
                er.response.headers
            );
          } else if (er.request) {
            Message.error(er.request);
          } else {
            Message.error('Error: ' + er.message);
          }
          Message.error(er.config);
        });
  }
  async toolbarClickSub(args: any) {
    if (args.item.id === 'advanced') {
      if (this.grid.getSelectedRecords().length !== 0) {
        var selectedElement = this.grid.getSelectedRecords() as any;
        loadingShow(true);
        await this.getTaskWithColumnName(selectedElement[0].target_table);
        this.targetTableText = selectedElement[0].target_table;
        this.TextareaVal = selectedElement[0].source_sql;
        loadingShow(false);
        this.setState({
          hideEditSubDialog: true,
        });
      } else {
        Message.error('No records selected  task');
      }
    }
    if (args.item.text === 'Add') {
      if (this.grid.getSelectedRecords().length !== 0) {
        var selectedElement = this.grid.getSelectedRecords()[0] as any;
        this.distingData();
        let data: any = [];
        this.sourceTableData = [];
        let objAddMapping = {
          TargetTable: selectedElement.target_table,
          TargetField: '',
          SourceTable: '',
          SourceField: '',
          Comments: '',
          Active: false,
        };
        this.activeColumnMapping = '';
        this.targetField = '';
        this.sourceField = '';
        this.mappingComments = '';
        data.push(objAddMapping);
        this.mappingIsEdit = false;

        try {
          const parser = new Parser();
          const ast = parser.astify(this.sourceSql);
          if (ast?.from) {
            ast.from.map((item: any) => {
              this.sourceTableData.push(item.table);
            });
          }
        } catch (error) {
          Message.error(error as string);
        }
        this.setState({
          hideAddEditDialogIsAdd: true,
        });
        this.setState({
          hideAddDialogMapping: true,
          mappingAddData: data,
          disabled: false,
        });
      } else {
        Message.error('No records selected  task');
      }
      //(this.state.disabled);
    }
    if (args.item.text === 'Edit') {
      if (this.gridSub.getSelectedRecords().length !== 0) {
        // this.distingData();
        var selectedElement = this.gridSub.getSelectedRecords()[0] as any;
        this.prevSourceTable = selectedElement.source_field;
        let data: any = [];
        let objAddMapping = {
          TargetTable: this.targetTableText,
          TargetField: selectedElement.target_field,
          SourceTable: selectedElement.source_table,
          SourceField: selectedElement.source_field,
          Comments: selectedElement.comments,
          Active: selectedElement.active === true ? 'ACTIVE' : 'INACTIVE',
        };
        this.targetField = selectedElement.target_field;
        this.sourceField = selectedElement.source_field;
        this.mappingComments = selectedElement.comments;
        this.activeColumnMapping =
            selectedElement.active === true ? 'ACTIVE' : 'INACTIVE';
        data.push(objAddMapping);
        this.mappingIsEdit = true;
        this.setState({ mappingAddData: data });
        this.setState({
          hideAddDialogMapping: true,
          disabled: true,
          hideAddEditDialogIsAdd: false,
        });
      } else {
        Message.error('No records selected Mapping');
      }
    }
    if (args.item.text === 'Delete') {
      if (this.gridSub.getSelectedRecords().length !== 0) {
        this.setState({ hideDeleteDialogMapping: true });
      } else {
        Message.error('No records selected Mapping');
      }
    }
  }
  distingData = () => {
    let data = this.state.TaskWithColumnData;
    this.state.TaskMapData.map((map: any) => {
      data.map((item: any) => {
        if (map.target_field === item.COLUMN_NAME) {
          const find = data.findIndex(
              (x: any) => x.COLUMN_NAME === map.target_field
          );
        }
      });
    });
    this.setState({ TaskWithColumnTempData: data });
  };
  statusTemplate(e: any) {
    return (
        <div>
          {e.status ? (
              <div
                  style={{
                    backgroundColor: '#339933',
                    width: '70px',
                    maxWidth: '70px',
                    minWidth: '70px',
                    height: 25,
                    borderRadius: 5,
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    color: 'white',
                  }}
              >
                ACTIVE
              </div>
          ) : (
              <div
                  style={{
                    backgroundColor: '#C90016',
                    width: '70px',
                    maxWidth: '70px',
                    minWidth: '70px',
                    height: 25,
                    borderRadius: 5,
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    color: 'white',
                  }}
              >
                INACTIVE
              </div>
          )}
        </div>
    );
  }
  enabledTemplate(e: any) {
    return (
        <div>
          {e.enabled ? (
              <div
                  style={{
                    backgroundColor: '#339933',
                    width: '60px',
                    maxWidth: '60px',
                    minWidth: '60px',
                    height: 25,
                    borderRadius: 5,
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    color: 'white',
                  }}
              >
                ACTIVE
              </div>
          ) : (
              <div
                  style={{
                    backgroundColor: '#C90016',
                    width: '60px',
                    maxWidth: '60px',
                    minWidth: '60px',
                    height: 25,
                    borderRadius: 5,
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    color: 'white',
                  }}
              >
                INACTIVE
              </div>
          )}
        </div>
    );
  }
  activeTemplate(e: any) {
    return (
        <div>
          {e.active ? (
              <div
                  style={{
                    backgroundColor: '#339933',
                    width: '70px',
                    maxWidth: '70px',
                    minWidth: '70px',
                    height: 25,
                    borderRadius: 5,
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    color: 'white',
                  }}
              >
                ACTIVE
              </div>
          ) : (
              <div
                  style={{
                    backgroundColor: '#C90016',
                    width: '70px',
                    maxWidth: '70px',
                    minWidth: '70px',
                    height: 25,
                    borderRadius: 5,
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    color: 'white',
                  }}
              >
                INACTIVE
              </div>
          )}
        </div>
    );
  }
  async rowSelect(el: any) {
    const selectedRows = this.grid.getSelectedRowIndexes();

    const isDisabled = selectedRows.length !== 1;

    const updatedToolbarOptions = this.state.toolbarOptionsTask.map(
        (option: any) => {
          if (option.id === 'edit') {
            return { ...option, disabled: isDisabled };
          }
          return option;
        }
    );

    this.setState({ selectedRows, toolbarOptionsTask: updatedToolbarOptions });
    try {
      this.task_id = el.data.task_id;
      this.task_name = el.data.task_name;
      this.targetTableText = el.data.target_table;
      this.sourceTable = el.data.source_table;
      this.getTaskMap(el.data.task_id);
      await this.getTaskWithColumnName(el.data.target_table);
      this.selIndex = el.rowIndex;
      this.sourceSql = el.data.source_sql;
      this.log_message = this.log_message =
          el.log_message == null ? '' : el.log_message;
      let data: any = [];
      let objAddMapping = {
        TargetTable: el.data.target_table,
        TargetField: '',
        SourceTable: el.data.source_table,
        SourceField: '',
        Comments: '',
        Active: false,
      };
      data.push(objAddMapping);
      this.setState({ mappingAddData: data });
    } catch (error) {
      Message.error(error as string);
    }
  }
  DerowSelect = (el: any) => {
    const selectedRows = this.grid?.getSelectedRowIndexes();

    const isDisabled = selectedRows?.length !== 1;

    const updatedToolbarOptions = this.state.toolbarOptionsTask.map(
        (option: any) => {
          if (option.id === 'edit') {
            return { ...option, disabled: isDisabled };
          }
          return option;
        }
    );
    this.setState({ selectedRows, toolbarOptionsTask: updatedToolbarOptions });
    this.task_id = -1;
    this.setState({ TaskMapData: [] });
  };
  getTaskMap(id: number) {
    getTaskMapping(id)
        .then((el) => {
          this.setState({ TaskMapData: el.data });
        })
        .catch((e) => {
          //(e);
        });
  }
  private onCreateAdvancedSql(): void {
    this.textareaObjAdvancedSql.addAttributes({ rows: 5 });
    this.textareaObjAdvancedSql.respectiveElement.style.height = '300px';
    this.textareaObjAdvancedSql.respectiveElement.style.width = '650px';
    this.textareaObjAdvancedSql.respectiveElement.style.overflow = 'auto';
    this.textareaObjAdvancedSql.respectiveElement.style.maxHeight = '300px';
  }
  private taskMappingDelete(obj: any) {
    DeleteTaskMapping(obj)
        .then()
        .catch((err) => {
          if (err.response) {
            Message.error(
                err.response.data +
                '\n' +
                err.response.status +
                '\n' +
                err.response.headers
            );
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
  }
  private onKeyUp(e: any) {
    let value = e.target.value;
    let data = new DataManager(this.state.TaskWithColumnData).executeLocal(
        new Query().where('COLUMN_NAME', 'startswith', value, true)
    );
    if (!value) {
      this.getTaskWithColumnName(this.targetTableText);
    } else {
      this.setState({
        TaskWithColumnData: data,
      });
    }
  }
  cellRender = (args: any) => {
    if ((args.column as Column).field === 'target_field') {
      const val = getValue((args.column as Column).field, args.data);
      ReactDOM.render(
          <div>
            <DropDownListComponent
                dataSource={this.state.TaskWithColumnData}
                value={val}
            />
          </div>,
          args.cell as Element
      );
    }
  };
  increaseItem = () => {
    let data = this.state.mappingAddData;
    let objAddMapping = {
      TargetTable: this.targetTableText,
      TargetField: '',
      SourceTable: this.sourceTable,
      SourceField: '',
      Comments: '',
      Active: false,
    };
    data.push(objAddMapping);
    this.setState({ mappingAddData: data });
  };
  timesAlert = () => {
    var element = document.querySelector('.alert-panel') as HTMLElement;
    element.classList.add('panel-alert-scale');
    setTimeout(() => {
      element.style.display = 'none';
    }, 1000);
  };
  renderTemplateAddMapping = () => {
    return (
        <div>
          <div className='panel-mapping'>
            <div className='panel-container'>
              <div className='alert-panel'>
                <div className='alert-panel-message'>bir mesajiniz var...</div>
                <div className='alert-times-icons'>
                  <FaTimes onClick={this.timesAlert} size={20} color='white' />
                </div>
              </div>
              <div className='panel-content'>
                <div className='panel-header'>
                  <div className='item-panel-mapping'> Target Table</div>
                  <div className='item-panel-mapping grow-property'>
                    Target Field
                  </div>
                  <div className='item-panel-mapping'>Source Table</div>
                  <div className='item-panel-mapping'>Source Field</div>
                  <div className='item-panel-mapping'>Comments</div>
                  <div className='item-panel-mapping'>Active</div>
                </div>
                <div className='panel-body-mapping'>
                  {this.state.mappingAddData.map((item: any) => (
                      <div className='panel-body-sub'>
                        <div className='item-panel-mapping'>
                          <TextBoxComponent
                              disabled={true}
                              value={item.TargetTable}
                          />
                        </div>
                        <div className='item-panel-mapping'>
                          <DropDownListComponent
                              dataSource={this.state.TaskWithColumnData}
                              fields={{ text: 'FULL_TEXT', value: 'COLUMN_NAME' }}
                              value={item.TargetField}
                              id='targetField'
                              width={300}
                              allowFiltering={true}
                              onChange={(e: any) => {
                                this.targetField = e.target.value;
                              }}
                          />
                        </div>
                        {this.sourceTableData.length > 0 && !this.mappingIsEdit ? (
                            <div className='item-panel-mapping'>
                              <DropDownListComponent
                                  value={item.SourceTable}
                                  dataSource={this.sourceTableData}
                                  onChange={(e: any) => {
                                    this.sourceTable = e.value;
                                    //(this.state.disabled);
                                  }}
                              />
                            </div>
                        ) : (
                            <div className='item-panel-mapping'>
                              <TextBoxComponent
                                  disabled={this.state.disabled}
                                  onChange={(e: any) => {
                                    this.sourceTable = e.value;
                                  }}
                                  value={item.SourceTable}
                              />
                            </div>
                        )}

                        <div className='item-panel-mapping'>
                          <TextBoxComponent
                              id='sourceField'
                              onChange={(e: any) => {
                                this.sourceField = e.target.value;
                              }}
                              value={item.SourceField}
                          />
                        </div>
                        <div className='item-panel-mapping'>
                          <TextBoxComponent
                              onChange={(e: any) => {
                                this.mappingComments = e.target.value;
                              }}
                              value={item.Comments}
                              id='comments'
                          />
                        </div>
                        <div className='item-panel-mapping'>
                          <DropDownListComponent
                              dataSource={this.isActiveData}
                              fields={{ text: 'Active', value: 'Active' }}
                              value={item.Active}
                              id='active'
                              onChange={(e: any) => {
                                this.activeColumnMapping = e.target.value;
                              }}
                          />
                        </div>
                      </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  };

  decreaseItem = (item: any) => {
    //(item);
  };

  renderTemplateAdvanceSql = () => {
    return (
        <div className='container-advanced' autoCorrect='off'>
          <div className='list-flex'>
            <div>
              <TextBoxComponent
                  multiline={true}
                  //value={this.state.richGeneralValue}
                  created={
                    (this.onCreateAdvancedSql = this.onCreateAdvancedSql.bind(this))
                  }
                  placeholder='Please enter your sql query here'
                  floatLabelType='Never'
                  value={this.TextareaVal}
                  onChange={(e: any) => {
                    this.TextareaVal = e.target.value;
                  }}
                  ref={(scope) => {
                    this.textareaObjAdvancedSql = scope;
                  }}
              />
            </div>
            <div className='list-column-target'>
              {/* <input className="e-input" type="text" id="textboxFilterColumn"  onKeyUp={this.onKeyUp.bind(this)} title="Search..."/> */}
              <ListViewComponent
                  id='list-taskmanager-column'
                  dataSource={this.state.TaskWithColumnData}
                  fields={this.fieldsTaskColumnList}
                  showCheckBox={false}
                  headerTitle={`columns of table ${this.targetTableText}`}
                  showHeader={true}
                  sortOrder='Ascending'
                  width={300}
                  height={300}
              ></ListViewComponent>
            </div>
          </div>
        </div>
    );
  };
  render() {
    return (
        <div>
          <div className='container-sourceadaptor'>
            <GridComponent
                dataSource={this.state.TaskData}
                //editSettings={this.editOptions}
                toolbar={this.state.toolbarOptionsTask}
                ref={(g) => (this.grid = g as GridComponent)}
                height='70vh'
                selectedRowIndex={this.state.TaskData.findIndex((el: any) => {
                  return el.task_id === this.context.currentTabTaskIndex;
                })}
                filterSettings={this.FilterOptions}
                allowFiltering={true}
                allowPaging={true}
                pageSettings={this.pageOptions}
                showColumnMenu={true}
                allowResizing={true}
                toolbarClick={this.toolbarClick.bind(this)}
                gridLines='Both'
                //queryCellInfo={this.cellRender}
                rowSelected={this.rowSelect.bind(this)}
                rowDeselecting={this.DerowSelect.bind(this)}
            >
              <ColumnsDirective>
                <ColumnDirective
                    allowEditing={false}
                    displayAsCheckBox={true}
                    type='checkbox'
                    headerText='Checkbox'
                    width={'30'}
                    textAlign='Left'
                />
                <ColumnDirective
                    field='task_id'
                    headerText='Task ID'
                    textAlign='Left'
                />
                <ColumnDirective
                    field='task_name'
                    headerText='Task Name'
                    textAlign='Left'
                />
                <ColumnDirective
                    field='companyName'
                    headerText='Company Name'
                    textAlign='Left'
                />
                <ColumnDirective
                    field='adapter_name'
                    headerText='Adapter'
                    textAlign='Left'
                />
                <ColumnDirective
                    field='target_table'
                    headerText='Target Table'
                    textAlign='Left'
                />
                <ColumnDirective field='seq' headerText='Seq' textAlign='Left' />
                <ColumnDirective field='primary_key' headerText='Primary Key' textAlign='Left' />
                <ColumnDirective
                    field='enabled'
                    headerText='Enabled'
                    template={this.enabledTemplate}
                    textAlign='Left'
                    width={'70px'}
                />
              </ColumnsDirective>
              <Inject
                  services={[
                    Edit,
                    Toolbar,
                    Filter,
                    Page,
                    ColumnMenu,
                    Resize,
                    Search,
                  ]}
              />
            </GridComponent>
          </div>
          {/* <div className='container-sourceadaptor'>
          <GridComponent
            //onClick={this.gridOnFocus}
            dataSource={this.state.TaskMapData}
            toolbar={this.toolbarOptionsTaskMapping}
            ref={(g) => (this.gridSub = g as GridComponent)}
            height='25vh'
            filterSettings={this.FilterOptions}
            allowFiltering={true}
            allowPaging={true}
            pageSettings={this.pageOptions}
            showColumnMenu={true}
            allowResizing={true}
            toolbarClick={this.toolbarClickSub.bind(this)}
            //actionBegin={this.begin.bind(this)}
            gridLines='Both'
            //queryCellInfo={this.cellRender}
            //rowSelected={this.rowselect.bind(this)}
          >
            <ColumnsDirective>
              <ColumnDirective
                field='target_table'
                headerText='Target Table'
                textAlign='Left'
                allowEditing={false}
              />
              <ColumnDirective
                field='target_field'
                headerText='Target Field'
                textAlign='Left'
              />
              <ColumnDirective
                field='source_table'
                headerText='Source Table'
                textAlign='Left'
                allowEditing={false}
              />
              <ColumnDirective
                field='source_field'
                headerText='Source Field'
                textAlign='Left'
              />
              <ColumnDirective
                field='comments'
                headerText='Comments'
                textAlign='Left'
              />

              <ColumnDirective
                field='active'
                template={this.activeTemplate}
                headerText='Active'
                width={'70px'}
                textAlign='Left'
              />
            </ColumnsDirective>
            <Inject
              services={[
                Edit,
                Toolbar,
                Filter,
                Page,
                ColumnMenu,
                Resize,
                Search,
              ]}
            />
          </GridComponent>
        </div> */}
          {this.state.hideAddEditDialog ? (
              <DialogComponent
                  animationSettings={{ delay: 1, duration: 500, effect: 'FadeZoom' }}
                  visible={this.state.hideAddEditDialog}
                  header={
                    this.state.hideAddEditDialogIsAdd ? 'Add Task' : 'Edit Task'
                  }
                  close={() => {
                    this.setState({ hideAddEditDialog: false });
                  }}
                  open={() => {
                    this.setState({ hideAddEditDialog: true });
                  }}
                  buttons={this.buttons}
                  width={'550px'}
                  isModal
                  showCloseIcon
                  height={700}
              >
                <div id='panCol' className='container ' autoCorrect='off'>
                  <div className='row '>
                    <div className='col-md-12'>
                      <div className='col-md-12'>
                        <TextBoxComponent
                            placeholder='Task Name'
                            floatLabelType='Auto'
                            value={this.task_name}
                            onChange={(el: any) => {
                              this.task_name = el.value;
                            }}
                        />
                      </div>
                      <div className='col-md-12'>
                        <DropDownListComponent
                            id='adapterTaskManager'
                            placeholder='Adapter'
                            floatLabelType='Auto'
                            value={this.adapter}
                            allowFiltering={true}
                            fields={{
                              text: 'AdaptorName',
                              value: 'AdaptorID',
                            }}
                            dataSource={this.state.adapterData}
                            onChange={(el: any) => {
                              this.adapter = el.value;
                            }}
                        />
                      </div>

                      <div className='col-md-12'>
                        <DropDownListComponent
                            id='targetTable'
                            placeholder='Target Table'
                            floatLabelType='Auto'
                            allowFiltering={true}
                            value={this.targetTableText}
                            fields={this.fieldsTaskName}
                            dataSource={this.state.TableNames}
                            onChange={(el: any) => {
                              this.targetTableText = el.value;
                            }}
                        />
                      </div>
                      <div className='col-md-12' style={{ marginTop: '10px' }}>
                        <span> DIG Full Sync Rule</span>
                        <TextAreaComponent
                            placeholder='DIG Full Sync Rule'
                            rows={5}
                            value={this.full_rule}
                            onChange={(e: any) => {
                              this.full_rule = e.value;
                            }}
                        />
                      </div>
                      <div className='col-md-12' style={{ marginTop: '10px' }}>
                        <span> DIG Inc. Sync Rule</span>
                        <TextAreaComponent
                            placeholder='DIG Inc. Sync Rule'
                            rows={5}
                            value={this.inc_rule}
                            onChange={(e: any) => {
                              this.inc_rule = e.value;
                            }}
                        />
                      </div>
                      <div className='col-md-12' style={{ marginTop: '10px' }}>
                        <span>Primary Key</span>
                        <TextBoxComponent
                            placeholder='Primary Key'
                            floatLabelType='Never'
                            value={this.primary_key}
                            onChange={(e: any) => {
                              this.primary_key = e.value;
                            }}
                        />
                      </div>
                      <div
                          className='col-md-12'
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            height: 'auto',
                          }}
                      >
                        <TextBoxComponent
                            placeholder='Seq'
                            style={{ height: 'full' }}
                            floatLabelType='Auto'
                            width={'50%'}
                            value={this.seq}
                            onChange={(e: any) => {
                              this.seq = e.value;
                            }}
                        />
                        <div
                            style={{
                              height: 'full',
                              marginTop: '24px',
                              marginBottom: '0px',
                              display: 'flex',
                              alignItems: 'center',
                              marginLeft: '24px',
                            }}
                        >
                          <p
                              style={{
                                height: 'full',
                                marginBottom: '0px',
                                marginRight: '24px',
                              }}
                          >
                            {' '}
                            Enabled
                          </p>
                          <SwitchComponent
                              change={(e: any) => {
                                this.enabled = e.checked;
                                //(this.enabled);
                              }}
                              checked={this.enabled}
                          />
                        </div>
                      </div>
                      <div className='col-md-12' style={{ display: 'none' }}>
                        <DropDownListComponent
                            placeholder='Service Type'
                            floatLabelType='Auto'
                            // value={this.state.Department}
                            // fields={{
                            //   text: 'DEPARTMENT_CODE',
                            //   value: 'DEPARTMENT_ID',
                            // }}
                            // dataSource={this.state.departmentData}
                            // onChange={(el: any) => {
                            //   this.setState({ Department: el.value });
                            // }}
                        />
                      </div>
                      <div
                          className='col-md-12'
                          style={{
                            marginTop: 15,
                            display: 'none',
                          }}
                      >
                        <div className='col-md-7'>Status</div>
                        <div className='col-md-5'>
                          <SwitchComponent
                              id='swichActiveOrInActive'
                              cssClass='handle-color'
                              change={(e: any) => {
                                this.status = e.checked;
                              }}
                              checked={this.status}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </DialogComponent>
          ) : null}
          {this.state.hideEditSubDialog ? (
              <DialogComponent
                  animationSettings={{ delay: 1, duration: 500, effect: 'FadeZoom' }}
                  visible={this.state.hideEditSubDialog}
                  header={'Advance Sql'}
                  close={() => {
                    this.setState({
                      hideEditSubDialog: false,
                    });
                  }}
                  open={() => {
                    this.setState({ hideEditSubDialog: true });
                  }}
                  content={this.renderTemplateAdvanceSql}
                  buttons={[
                    {
                      click: () => {
                        this.request();
                      },
                      buttonModel: {
                        content: 'Test Sql',
                      },
                    },
                    {
                      click: () => {
                        this.addAndEditTaskMapp();
                      },
                      buttonModel: {
                        content: 'Save',
                        isPrimary: true,
                      },
                    },
                    {
                      click: () => {
                        this.setState({
                          hideEditSubDialog: false,
                        });
                      },
                      buttonModel: {
                        content: 'Cancel',
                      },
                    },
                  ]}
                  width={'1000px'}
                  isModal
                  style={{ maxHeight: '400px', overflow: 'auto' }}
                  showCloseIcon
                  height={'auto'}
              >
                <div className='row'></div>
              </DialogComponent>
          ) : null}
          {this.state.hideDeleteDialog ? (
              <DialogComponent
                  isModal={true}
                  id='defaultDialogDelete'
                  showCloseIcon={true}
                  visible={this.state.hideDeleteDialog}
                  header='Confirmation'
                  width={200}
                  height={'auto'}
                  buttons={this.buttonsDelete}
                  open={() => {
                    this.setState({ hideDeleteDialog: true });
                  }}
                  close={() => {
                    this.setState({ hideDeleteDialog: false });
                  }}
              >
                <div className='container'>
                  <div className='row'>
                    <span>Are you sure?</span>
                  </div>
                </div>
              </DialogComponent>
          ) : null}
          {this.state.hideDeleteDialogMapping ? (
              <DialogComponent
                  isModal={true}
                  id='defaultDialogDelete'
                  showCloseIcon={true}
                  visible={this.state.hideDeleteDialogMapping}
                  header='Confirmation'
                  width={200}
                  height={'auto'}
                  buttons={this.buttonsDeleteMapping}
                  open={() => {
                    this.setState({ hideDeleteDialogMapping: true });
                  }}
                  close={() => {
                    this.setState({ hideDeleteDialogMapping: false });
                  }}
              >
                <div className='container'>
                  <div className='row'>
                    <span>Are you sure?</span>
                  </div>
                </div>
              </DialogComponent>
          ) : null}

          {this.state.hideAddDialogMapping ? (
              <DialogComponent
                  isModal={true}
                  id='defaultDialogAddMapping'
                  showCloseIcon={true}
                  visible={this.state.hideAddDialogMapping}
                  header='Task Mapping'
                  width={1300}
                  height={'auto'}
                  content={this.renderTemplateAddMapping}
                  buttons={this.buttonsAddMapping}
                  open={() => {
                    this.setState({ hideAddDialogMapping: true });
                  }}
                  close={() => {
                    this.setState({ hideAddDialogMapping: false });
                  }}
              >
                <div className='container'></div>
              </DialogComponent>
          ) : null}
        </div>
    );
  }
}
